import * as ReactGA from 'react-ga';

// when user searches for coruses
export const gaSearchCourses = (searchTerm: string) => {
  ReactGA.event({
    category: 'Course',
    action: `Search courses: ${searchTerm}`
  });
}

// When user clicks start in CourseInfo (add or remove to users list)
export const gaCourseStarClicked = (remove: boolean) => {
  ReactGA.event({
    category: 'Course',
    action: remove ? 'Remove course from list' : 'Add course to list'
  });
}

export const gaWriteFeedbackClicked = () => {
  ReactGA.event({
    category: 'Feedback',
    action: 'Opened feedback form'
  });
}

export const gaUploadMaterialClicked = () => {
  ReactGA.event({
    category: 'Material',
    action: 'Opened material form'
  });
}

export const gaFeedbacksTabClicked = () => {
  ReactGA.event({
    category: 'Feedback',
    action: 'Feedback tab clicked'
  });
}

export const gaMaterialsTabClicked = () => {
  ReactGA.event({
    category: 'Material',
    action: 'Material tab clicked'
  });
}

export const gaMaterialTypeClicked = (type: string) => {
  ReactGA.event({
    category: 'Material',
    action: `${type} clicked`
  });
}

export const gaOpenFileClicked = () => {
  ReactGA.event({
    category: 'Material',
    action: `File open clicked`
  });
}